import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

interface SelectableDraftRow {
  nome: string | null;
  isSelected: () => boolean;
  toggle: () => void;
}

// Bozza da eliminare: la spunta non apre la bozza
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-draft-select-cell',
  imports: [TranslocoPipe, MatCheckboxModule],
  template: `
    <mat-checkbox
      [checked]="itemData.isSelected()"
      [attr.aria-label]="(('orders.ui.seleziona' | transloco) + &quot; &quot;) + (itemData.nome ?? '')"
      (click)="$event.stopPropagation()"
      (change)="itemData.toggle()"
    />
  `,
})
export class DraftSelectCell {
  @Input({ required: true }) itemData!: SelectableDraftRow;
  @Input() infoColumn: unknown;
  @Input() _reloadData?: { emit: () => void };
}
